// src/components/NewRunDialog.jsx
import { Dialog, DialogTitle, DialogContent, Typography } from "@mui/material";
import RunFormFields from "./RunFormFields";
import { createRunWithDictId, rerunRun } from "../utils/api";

export default function NewRunDialog({
  open,
  onClose,
  onSuccess,
  preselectDictId = "",
  mode = "new",
  runId = null,
  initialValues = {},
  projectId = null,
}) {
  const handleSubmit = async (formValues) => {
    if (mode === "rerun" && runId) {
      await rerunRun(runId, formValues);
      onSuccess?.(runId);
    } else {
      const result = await createRunWithDictId({ ...formValues, project_id: projectId || undefined });
      onSuccess?.(result.runId);
    }
    onClose?.();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{ sx: { borderRadius: 2 } }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Typography variant="h6" fontWeight={700}>
          {mode === "rerun" ? "Rerun analysis" : "New analysis"}
        </Typography>
      </DialogTitle>

      <DialogContent dividers sx={{ pt: 2, pb: 2 }}>
        <RunFormFields
          preselectDictId={preselectDictId}
          initialValues={initialValues}
          onCancel={onClose}
          onSuccess={handleSubmit}
        />
      </DialogContent>
    </Dialog>
  );
}